var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
import { IsDateString, IsIn, IsInt, IsOptional, IsString, IsUrl, MaxLength } from 'class-validator';
import { IsAfterDateOrEqual } from '../../utils/validators/is-after';
import { IsBeforeOrToday } from '../../utils/validators/is-before-now';
import { ProjectTypeValues } from './project-type';
/**
 * Affected endpoints
 * POST /manfredite/projects/<id>
 * PUT /manfredite/projects/<id>
 */
export class ProjectUpdateRequest {
}
__decorate([
    Expose(),
    IsIn(ProjectTypeValues),
    __metadata("design:type", String)
], ProjectUpdateRequest.prototype, "type", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], ProjectUpdateRequest.prototype, "title", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], ProjectUpdateRequest.prototype, "description", void 0);
__decorate([
    Expose(),
    IsDateString(),
    IsBeforeOrToday(),
    __metadata("design:type", Date)
], ProjectUpdateRequest.prototype, "dateFrom", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsDateString(),
    IsBeforeOrToday(),
    IsAfterDateOrEqual('dateFrom'),
    __metadata("design:type", Date)
], ProjectUpdateRequest.prototype, "dateTo", void 0);
__decorate([
    Expose(),
    IsInt({ each: true }),
    __metadata("design:type", Array)
], ProjectUpdateRequest.prototype, "technologies", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsInt(),
    __metadata("design:type", Number)
], ProjectUpdateRequest.prototype, "logoId", void 0);
__decorate([
    Expose(),
    IsUrl({ require_protocol: true }),
    MaxLength(255),
    IsOptional(),
    __metadata("design:type", String)
], ProjectUpdateRequest.prototype, "url", void 0);
//# sourceMappingURL=project-update.request.js.map